module.exports = __webpack_public_path__ + "img/leacock-logo.0d04226c.jpg";